import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import http from './http';

let appVersion = ''

http.get<{ version: string }>('api/version')
    .then(res => appVersion = res.data.version)
    .catch(() => appVersion = 'unknown')

setInterval(() => {
    http.get<{ version: string }>('api/version')
        .then(res => {
            if(res.data.version === appVersion) return
            window.location.reload()
        })
}, 60000)

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
